import React, { Component } from 'react'
import Menu from './Menu'
import styles from './index.module.less'
import NewView from '@common/NewView'

export default class extends Component {
  shouldComponentUpdate(nextProps) {
    const {
      location: { pathname }
    } = this.props
    const { pathname: nextPathName } = nextProps.location
    return nextPathName !== pathname
  }

  render() {
    const { children } = this.props

    return (
      <NewView title="VR全景管理">
        <div className={styles['content-menus']}>
          <Menu />
        </div>
        <div className={styles['content-main']}>{children}</div>
      </NewView>
    )
  }
}
